import { cityApis } from '@shared/apis';
import { genericQueryWithParams } from './generics';

export const useGetCitiesLight = genericQueryWithParams<cityApis.GetCitiesLight>(
  cityApis.getCitiesLight
);
